<!-- eslint-disable max-len -->
<template>
  <div class="about-team_ate" :class="{ [curTheme]: true }">

    <page-header>
      <h1>Эксперты</h1>
    </page-header>

    <page-text>

      <div class="ate_items">

          <div
            v-for="(v, i) in items"
            class="ate_item"
            :key="`item-${i}`">
            <img class="ate_image"
                 :src="`/static/data/experts/${v.id}.png`">
            <span class="ate_text">
              <span class="ate_text-block ate_name">{{ v.name }}</span>
              <span class="ate_text-block ate_org">{{ v.org }}</span>
              <span class="ate_text-block ate_role">{{ v.role }}</span>
              <a
                v-if="v.link"
                :href="v.link"
                class="ate_text-block ate_link"
                target="_blank"
                :class="`ate_link--${linkType(v.link)}`">
                {{ linkLabel(v.link) }}
              </a>
            </span>
          </div>

      </div>

    </page-text>

    <page-footer/>
  </div>
</template>

<script>
/* eslint-disable max-len */
import PageHeader from '../PageHeader';
import PageText from '../PageText';
import PageFooter from '../PageFooter';

export default {

  components: { PageHeader, PageText, PageFooter },

  data() {
    return {
      dialogVisible: false,
      items: [
        {
          id: 'pustovgar',
          name: 'Пустовгар Андрей Петрович',
          role: 'проректор МГСУ по научной работе',
        },
        {
          id: 'rumiantcev',
          name: 'Румянцев Максим Валерьевич',
          role: 'Заместитель министра образования Красноярского края',
        },
        {
          id: 'adamtcevich',
          name: 'Адамцевич Алексей Олегович',
          org: 'МГСУ',
          role: 'Руководитель управления научной политики',
        },
        {
          id: 'kadiev',
          name: 'Кадиев Исмаил Гаджиевич',
          org: 'СПбПУ',
          role: 'Директор Центра интеллектуальной собственности',
        },
        {
          id: 'medvedeva',
          name: 'Медведева Оксана Олеговна',
          org: 'РАНХиГС',
          role: 'Руководитель отдела научно-информационного развития',
        },
      ],
      curItem: null,
    };
  },

  created() {
    this.items.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  },

  methods: {

    showDialog(item) {
      this.curItem = item;
      this.dialogVisible = true;
    },

    linkType(link) {
      if (link.indexOf('facebook.com') > -1) {
        return 'fb';
      }
      return 'vk';
    },

    linkLabel(link) {
      if (link.indexOf('facebook.com') > -1) {
        return 'Facebook';
      }
      return 'ВКонтакте';
    },

  },

};
</script>

<style lang="scss">
@import '../../styles/common/main';
.ate_items {
  @include clearfix;
  padding-bottom: 30px;
  .ate_item {
    position: relative;
    @include clearfix;
    margin: 20px 0;
    width: 33.3333333%;
    float: left;
    @media (max-width: 1255px) {
      width: 50%;
      &:nth-last-of-type(2n) {
        clear: left;
      }
    }
    @media (max-width: 767px) {
      width: 100%;
      float: none;
      max-width: 450px;
      margin: 25px auto;
    }
    .ate_image {
      width: 180px;
      height: auto;
      float: left;
      @media (max-width: 830px) {
        width: 120px;
      }
    }
    .ate_text {
      display: block;
      overflow: hidden;
      padding: 45px 20px 0 15px;
      @media (max-width: 830px) {
        padding-top: 32px;
      }
      @media (max-width: 450px) {
        position: relative;
        overflow: hidden;
        transform: translateY(0);
      }
      .ate_text-block {
        margin-bottom: 5px;
        display: block;
      }
      .ate_name,
      .ate_org {
        font-size: 19px;
        line-height: 24px;
        @media (max-width: 830px) {
          font-size: 17px;
          line-height: 22px;
        }
      }
      .ate_org {
        color: #939393;
      }
      .ate_role {
        font-size: 15px;
        line-height: 20px;
        @media (max-width: 600px) {
          font-size: 14px;
          line-height: 17px;
        }
      }
      .ate_link {
        font-size: 14px;
        padding-top: 1px;
        color: #a45578;
        transition: color .3s;
        padding-left: 23px;
        position: relative;
        cursor: pointer;
        &:hover {
          color: #d16b98;
        }
        @media (max-width: 600px) {
          padding-left: 21px;
          font-size: 13px;
        }
        &:before {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          top: 4px;
          width: 19px;
          height: 12px;
          @media (max-width: 600px) {
            width: 15px;
            height: 8px;
          }
        }
        &.ate_link--vk {
          width: 17px;
          height: 11px;
          &:before {
            background: 0 0 no-repeat url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAATCAYAAAAeVmTJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCRDFFQjJDRkM1MkExMUU4OTVDQjhFRjMyNTU0MjU4NiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCRDFFQjJEMEM1MkExMUU4OTVDQjhFRjMyNTU0MjU4NiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkJEMUVCMkNEQzUyQTExRTg5NUNCOEVGMzI1NTQyNTg2IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkJEMUVCMkNFQzUyQTExRTg5NUNCOEVGMzI1NTQyNTg2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+gYmOPgAAAV5JREFUeNq8VdFtgzAQdU5dgBXCCO4IyQjNCInEAjBCGIAPGKEdoR4hrMAIZYWY6ly5zt35XLU9ySDZh+/x3jt71zSNKYwDMbf6MZsfxDAM5sm/W2bdJRvv/bj5UTH5vR8dMb/lnwUc/c4z8cFsvPhREyy8Mvkb6CMxP2ZA1OAfE7O4J6h3Qr5hWHgR1p2XY4HMpi2jvzbOgnxBQgNI+ySYMGVjLmChzQBwAcQXogI2NHEVWJjjmhCZsBfYiI1llW3MmXGT8xLLCgk9q+KvKoH+8B4FgF0qKSQIe6HADf+Oc7tFsO/YWVRMlP+AMMsstOwoFAj+sYIM1GH2AMKgXv8awDi3+4NaFUpVaUB86+FfDksBAeGDE7ZuSWhu0wcgkNnwVHhMb/nPivvF4kWYBRH8USulWaK8iwLIIZzGoKT4iGZdMyDSLssBuWpBxGatcfM3oqhj2l0C//nNXYABANWkUW7YrzUJAAAAAElFTkSuQmCC');
            background-size: contain;
          }
        }
        &.ate_link--fb {
          width: 25px;
          height: 16px;
          &:before {
            background: 0 0 no-repeat url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAATCAYAAAAeVmTJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo2NWRlZDg3Yy0yMGJkLWUzNDMtYmI5MC1kZGZlNWVjZDBhMzAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUY3QTQ3NzdDNTJBMTFFODlBRjE4QjI5RjNBMzhGODIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUY3QTQ3NzZDNTJBMTFFODlBRjE4QjI5RjNBMzhGODIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjY1ZGVkODdjLTIwYmQtZTM0My1iYjkwLWRkZmU1ZWNkMGEzMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2NWRlZDg3Yy0yMGJkLWUzNDMtYmI5MC1kZGZlNWVjZDBhMzAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4JRjW3AAAA10lEQVR42mL8//8/Ay6QnZ0tCKRcGCgDZ6dOnXoPnwIWAgasooIj3gOxED4FTAQMEGSgHAhCQ5TskCAF7AEFPRI/FIiViNFILUfMAsZ7Olp6IjoaqeGI98gOIBT05KQJYsA9JAekAal3UGxMT0cgAyVyNFHbEQz0dkQnKP8D04MJTADIroCWCULQ8oH2IQG09D0eMUF65A5jYELsgOaOTmjCDIUmSJJyCCWOcIHis9CoYYA6oHzEJcxRRwxPRxDKHenQKplQowXeikLKKfC6BVt5ggwAAgwAzpI2XQWVSKgAAAAASUVORK5CYII=');
            background-size: contain;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/AboutExperts.vue